import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function EULA() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
      </header>
      </div>
    </main>
   <main className="terms-container faq  terms-nd-condition my-3">
       <div  className={`container ${styles.container}`}>
       <header className="terms-header">
         <h1 className='main-heading text-left'>ResuMate End User License Agreement (EULA)</h1>
         <p>Last Updated: January 3, 2026</p>
         <p>
          This End User License Agreement ("Agreement") is a legal agreement between you ("User") and Sparkle from Within LLC 
          ("Company," "ResuMate," "we," or "us") governing your use of the ResuMate mobile application and related services 
          (the "App").
         </p>
         <p>
          By downloading, accessing, or using the App, you agree to be bound by this Agreement and Apple's 
          standard EULA terms <a className='email cursor-pointer' href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/">(https://www.apple.com/legal/internet-services/itunes/dev/stdeula/)</a>. If you do not agree, do not use the App.
         </p>
       </header>
 
       <article>
         <h2 className='inner-heading'>1. License Grant</h2>
          <ul className='terms-list'>
           <li>ResuMate grants you a limited, non-exclusive, non-transferable, revocable license to download and use the App for your personal, non-commercial purposes, in accordance with this Agreement and our Terms of Use.</li>
           <li>You may not:
             <ul className='terms-list'>
               <li>Copy, modify, distribute, sell, lease, sublicense, reverse engineer, decompile, or attempt to extract the source code of the App.</li>
               <li>Use the App for commercial purposes, automation, or any activity that violates this Agreement, applicable law, or the rights of others.</li>
             </ul>
           </li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>2. User-Generated Content</h2>
          <ul className='terms-list'>
           <li>ResuMate allows users to create and share resume-style profiles, video calls, and other personal content ("User Content").</li>
           <li>You retain ownership of your content but grant ResuMate a worldwide, royalty-free, non-exclusive license to use, display, host, process, and analyze your content for the purpose of operating, improving, and promoting the App.</li>
           <li>You are solely responsible for your content and agree that you will not:
             <ul className='terms-list'>
               <li>Post false, misleading, or unlawful information.</li>
               <li>Include sensitive data (government IDs, addresses, financial details).</li>
               <li>Upload content that violates this Agreement, applicable laws, or another user's rights.</li>
               <li>Submit AI-generated content that impersonates, misleads, or harms others.</li>
             </ul>
           </li>
           <li>You are responsible for all AI-generated content created through the App, including summaries and suggestions based on your inputs.</li>
         </ul>
       </article>
       
 
       <article>
         <h2 className='inner-heading'>3. Objectionable Content and Abusive Behavior</h2>
          <ul className='terms-list'>
           <li>ResuMate enforces a zero-tolerance policy for objectionable content and abusive behavior. You agree not to:
             <ul className='terms-list'>
               <li>Upload or share obscene, pornographic, violent, hateful, or discriminatory material.</li>
               <li>Harass, threaten, or abuse other users.</li>
               <li>Promote illegal activity, self-harm, or unsafe behavior.</li>
               <li>Impersonate others or misrepresent your identity.</li>
             </ul>
           </li>
           <li>ResuMate may remove objectionable content and permanently suspend or delete accounts that violate this policy.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>4. Content Moderation and User Safety</h2>
          <ul className='terms-list'>
           <li>ResuMate uses automated tools and human moderators to monitor and maintain a safe environment.</li>
           <li>The App provides:
             <ul className='terms-list'>
               <li>Filtering mechanisms to limit objectionable content.</li>
               <li>Reporting tools that allow users to flag inappropriate or abusive content.</li>
               <li>Blocking functions to prevent further contact from specific users.</li>
             </ul>
           </li>
           <li>Reports of objectionable content are reviewed promptly. Violating content and accounts may be removed or restricted as appropriate.</li>
           <li>ResuMate is not responsible for the actions of other users or for outcomes arising from interactions online or offline.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>5. Video Calls and Interactions</h2>
          <ul className='terms-list'>
           <li>Users must complete a video call before private chat access is enabled.</li>
           <li>ResuMate does not conduct background checks and is not responsible for interactions or outcomes outside the App.</li>
           <li>Always use personal judgment and safety precautions when interacting with others, both online and offline.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>6. Termination</h2>
         <p>You may delete your account at any time. ResuMate may suspend or terminate your account without notice if you violate this Agreement, Terms of Use, or Community Guidelines. Termination includes removal of User Content and loss of access to App features.</p>
       </article>
 
       <article>
         <h2 className='inner-heading'>7. Disclaimer</h2>
          <ul className='terms-list'>
           <li>The App is provided "as is" without warranties, express or implied.</li>
           <li>ResuMate does not guarantee:
             <ul className='terms-list'>
               <li>Matches, compatibility, or outcomes.</li>
               <li>Uninterrupted access, availability, or functionality.</li>
               <li>Accuracy or suitability of AI-generated content.</li>
             </ul>
           </li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>8. Limitation of Liability</h2>
         <p>To the fullest extent permitted by law, ResuMate and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including those arising from:</p>
          <ul className='terms-list'>
           <li>Use of the App or User Content.</li>
           <li>Interactions with other users, online or offline.</li>
           <li>Loss of data, messages, or personal information.</li>
           <li>AI-generated content or inaccuracies.</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>9. Indemnification</h2>
         <p>You agree to indemnify and hold harmless ResuMate, its affiliates, officers, employees, and agents from any claims, losses, damages, or expenses arising from your use of the App or violation of this Agreement.</p>
       </article>
 
       <article>
         <h2 className='inner-heading'>10. Force Majeure</h2>
         <p>ResuMate shall not be liable for any delay, interruption, or failure to perform resulting from events beyond its reasonable control, including but not limited to:</p>
          <ul className='terms-list'>
           <li>Natural disasters, fires, floods, earthquakes, or pandemics</li>
           <li>Internet, network, or power failures</li>
           <li>App Store or platform disruptions</li>
           <li>Hosting or cloud service outages</li>
         </ul>
       </article>
 
       <article>
         <h2 className='inner-heading'>11. Governing Law</h2>
         <p>This Agreement is governed by the laws of the State of Arizona, USA, without regard to conflict-of-law principles.</p>
       </article>
 
       <article>
         <h2 className='inner-heading'>12. Contact</h2>
         <p>For support, reporting objectionable content, or questions about this Agreement, contact:</p>
         <p>Sparkle from Within LLC</p>
         <p>4539 N 22nd St, Ste N, Phoenix, AZ 85016</p>
         <p><a className='email' href="mailto:info@resumate.org">info@resumate.org</a></p>
       </article>

       <article>
         <h2 className='inner-heading'>13. Entire Agreement</h2>
         <p>This EULA, together with the Terms of Use, Privacy Policy, and Community Guidelines, constitutes the entire agreement between you and ResuMate regarding your use of the App.</p>
       </article>

       <footer className="terms-footer">
         © 2026 ResuMate. All rights reserved.
       </footer>
       </div>
     </main>
     {/* Footer */}
     <section className={styles.footer}>
       <div className={`container ${styles.container}`}>
         <div className="row">
           <div className="col-sm-4">
             <div className={styles.footerLeft}>
               <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
             </div>
                     <div className={`${styles.footerMid} ${styles.right}`}>
               <h4>Follow us</h4>
                <ul className='terms-list'>
                 <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                 <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                 <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
               </ul>
             </div>

           </div>
           <div className="col-sm-4">
                     <div>
               <ul className={styles.termsConditonList}>
                 <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                 <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                 <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                 <li><Link to="/eula">EULA</Link></li>
                 <li><Link to="/safety">Safety</Link></li>
               </ul>
             </div>
           </div>
           <div className="col-sm-4">
                 <div className={styles.footerMid}>
               <h4 className="text-right">Get the app</h4>
               <ul className="text-right">
                 <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                 <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>
               </ul>
             </div>

           </div>
           <div className="col-sm-12">
             <h5>Copyright © 2026 ResuMate.  All rights reserved.</h5>
           </div>
         </div>
       </div>
     </section>
   </>
  );
}

export default EULA;
